const DEFAULT_ALLOWED_PROTOCOLS = new Set(['https:'])

export interface SafeExternalUrlOptions {
  allowedProtocols?: readonly string[]
}

export function safeExternalUrl(
  raw: string | null | undefined,
  options: SafeExternalUrlOptions = {},
): string | null {
  if (typeof raw !== 'string') return null

  const trimmed = raw.trim()
  if (!trimmed || hasControlChars(trimmed)) return null

  let parsed: URL
  try {
    parsed = new URL(trimmed)
  } catch {
    return null
  }

  const allowed = options.allowedProtocols
    ? new Set(options.allowedProtocols)
    : DEFAULT_ALLOWED_PROTOCOLS
  if (!allowed.has(parsed.protocol)) return null

  return parsed.href
}

function hasControlChars(value: string): boolean {
  for (let i = 0; i < value.length; i += 1) {
    const code = value.charCodeAt(i)
    if (code <= 0x1f || code === 0x7f) return true
  }
  return false
}
